import { createWebHashHistory , createWebHistory, createRouter, RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "Index",
    component: () => import("@/views/Index.vue"),
  },
  {
    path: "/mission1",
    name: "Mission1",
    component: () => import("@/views/Mission1.vue"),
  },
  {
    path: "/mission2",
    name: "Mission2",
    component: () => import("@/views/Mission2.vue"),
  },
  {
    path: "/mission2/:displayId/:srcType/:data",
    name: "Mission2-2",
    component: () => import("@/views/Mission2.vue"),
  }
];

export default createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if(to.query.q){
      return {};
    }else{
      console.log('gotop');
      return {left:0,top:0}
    }
  }
});